import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import UserService from "../services/UserService";
import UserCollectionsService from "../services/UserCollectionsService";
import ProfileEditor from "./ProfileEditor";
import ChangePassword from "./ChangePassword";
import { useSnackbar } from "notistack";
import getUserFriendlyMessages from "../genericFunctions/getUserFriendlyMessages";
import { UPDATED } from "../genericFunctions/operationTypeConstants";

const Account = () => {
  const authContext = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const profileService = {
    getConsultant: () => UserService.getConsultant(),
    getProfilePic: () => UserService.getProfilePic(),
    uploadProfilePic: (formData) => UserService.uploadProfilePic(formData),
    updateUserInfo: (userInfo) => UserService.updateUserInfo(userInfo),
    updatePrivateResumeStatus: (privateResume) =>
      UserService.updatePrivateResumeStatus({ privateResume: privateResume }),
    createTranslation: (language, seedFromLanguage) =>
      UserCollectionsService.addTranslation(language, seedFromLanguage),
    deleteTranslation: (translationId) =>
      UserCollectionsService.deleteTranslation(translationId),
    updateTranslationInfo: (translationId, object) =>
      UserCollectionsService.updateTranslationInfo(translationId, object),
    createTranslationItem: (translationId, objectToAdd, collectionName) =>
      UserCollectionsService.createTranslationItem(
        translationId,
        objectToAdd,
        collectionName
      ),
    updateTranslationItem: (translationId, objectToUpdate, collectionName) =>
      UserCollectionsService.updateTranslationItem(
        translationId,
        objectToUpdate,
        collectionName
      ),
    deleteTranslationItem: (translationId, objectToDeleteId, collectionName) =>
      UserCollectionsService.deleteTranslationItem(
        translationId,
        objectToDeleteId,
        collectionName
      ),
  };

  const saveNewPassword = (
    e,
    currentPassword,
    newPassword,
    confirmedPassword
  ) => {
    e.preventDefault();
    if (newPassword === confirmedPassword) {
      UserService.updateUserPassword(currentPassword, newPassword).then(
        (data) => {
          const { message } = data;
          if (!message.msgError) {
            enqueueSnackbar(
              getUserFriendlyMessages(UPDATED, "password").msgBody,
              { variant: "info" }
            );
          } else if (message.msgBody === "Unauthorized") {
            enqueueSnackbar(message.msgBody, { variant: "error" });
            authContext.setUser({ username: "", role: "" });
            authContext.setIsAuthenticated(false);
          } else {
            enqueueSnackbar(message.msgBody, { variant: "error" });
          }
        }
      );
    } else {
      enqueueSnackbar("Passwords don't match", { variant: "error" });
    }
  };

  return (
    <ProfileEditor
      profileService={profileService}
      showPrivateResumeToggle={
        authContext.user.role.includes("externaluser") === false
      }
      changePasswordComponent={
        <ChangePassword saveNewPassword={saveNewPassword} />
      }
    />
  );
};

export default Account;
